import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Activity, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { returnCountdown } from "@/lib/format";

function sevColor(s) {
  if (s === "Ruled Out" || s === "Suspended") return "#F87171";
  if (s === "Doubtful") return "#FB923C";
  return "#FFB020";
}

export function TopInjuriesStrip() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/top-injuries?limit=8")
      .then((r) => setItems(r.data?.injuries || []))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section data-testid="top-injuries-strip" className="max-w-[1200px] mx-auto px-4 sm:px-6 -mt-6 sm:-mt-10 relative z-10">
      <div className="rounded-2xl bg-[#0B0F18]/90 backdrop-blur border border-[#232D42] p-4 sm:p-5">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-base font-heading font-bold text-slate-100 flex items-center gap-2">
            <Activity size={16} className="text-[#F87171]" /> Today's biggest injuries
            <span className="h-1.5 w-1.5 rounded-full bg-[#00E5A3] sq-pulse" />
          </h2>
          <Link to="/status" data-testid="top-injuries-viewall" className="text-xs font-mono text-[#38BDF8] hover:underline flex items-center gap-1">
            Full report <ArrowRight size={12} />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {items.map((p, i) => {
            const color = sevColor(p.severity);
            const rc = returnCountdown(p.return_date);
            return (
              <Link key={p.player_id || i} to={p.player_id ? `/players/${p.player_id}` : "/status"}
                data-testid={`top-injury-${p.player_id || i}`}
                className="flex items-center gap-3 rounded-xl bg-[#0F1420] border border-[#232D42] p-3 hover:border-[#38BDF8]/50 transition-colors">
                {p.headshot
                  ? <img src={p.headshot} alt="" className="h-10 w-10 rounded-full object-cover bg-[#151B2B] shrink-0" />
                  : <div className="h-10 w-10 rounded-full bg-[#151B2B] shrink-0" />}
                <div className="min-w-0">
                  <div className="flex items-center gap-1.5">
                    <span className="text-sm font-semibold text-slate-100 truncate">{p.name}</span>
                    <span className="text-[9px] font-mono uppercase px-1.5 py-0.5 rounded"
                      style={{ color, background: `${color}1a` }}>{p.status}</span>
                  </div>
                  <p className="text-[11px] text-slate-500 truncate">
                    {p.league} · {p.team}{p.injury ? ` · ${p.injury}` : ""}
                  </p>
                  {rc && <p className="text-[10px] font-mono mt-0.5" style={{ color: rc.soon ? "#FFB020" : "#64748B" }}>{rc.label}</p>}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
